import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmashInputComponent } from './smash-input/smash-input.component';
import { SmashInputMessageComponent } from './smash-input-message/smash-input-message.component';
import { SmashInputMobileComponent } from './smash-input-mobile/smash-input-mobile.component';
import { SmashInputMessageMobileComponent } from './smash-input-message-mobile/smash-input-message-mobile.component';
import { SmashInputTagComponent } from './smash-input-tag/smash-input-tag.component';
import { SmashCheckboxComponent } from './smash-checkbox/smash-checkbox.component';
import { SmashSwitchOnOffComponent } from './smash-switch-on-off/smash-switch-on-off.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SmashInputFileComponent } from './smash-input-file/smash-input-file.component';
import { SharedModule } from '@app/shared/shared.module';
import { SmashSwitchSendReceiveComponent } from './smash-switch-send-receive/smash-switch-send-receive.component';


@NgModule({
  declarations: [
    SmashInputComponent,
    SmashInputMessageComponent,
    SmashInputMobileComponent,
    SmashInputMessageMobileComponent,
    SmashInputTagComponent,
    SmashCheckboxComponent,
    SmashSwitchOnOffComponent,
    SmashSwitchSendReceiveComponent,
    SmashInputFileComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SmashInputComponent,
    SmashInputMobileComponent,
    SmashInputMessageComponent,
    SmashInputMessageMobileComponent,
    SmashInputTagComponent,
    SmashCheckboxComponent,
    SmashSwitchOnOffComponent,
    SmashSwitchSendReceiveComponent,
    SmashInputFileComponent
  ]
})
export class SmashFormsModule { }
